module.exports = "././img/new-footer.png";


//////////////////
// WEBPACK FOOTER
// ../assets/img/new-footer.png
// module id = 822
// module chunks = 0